import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Catalogue.css';

import { useFavorites } from '../../context/FavoritesContext';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';

import FilterSidebar from '../../components/FilterSidebar/FilterSidebar';
import pb from '../../services/pocketbase';
import Select from 'react-select';

function Catalogue() {
  const { favorites, toggleFavorites } = useFavorites();
  const { addToCart } = useCart();
  const { user } = useAuth();
  
  // État pour l'édition admin
  const [editingProduct, setEditingProduct] = useState(null);
  const [editedProduct, setEditedProduct] = useState({});

  // Charger les filtres depuis sessionStorage au démarrage
  const loadFiltersFromStorage = () => {
    try {
      const savedFilters = sessionStorage.getItem('catalogueFilters');
      if (savedFilters) {
        return JSON.parse(savedFilters);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des filtres:', error);
    }
    return {
      categories: [],
      colors: [],
      materials: [],
      pearlTypes: [],
      minPrice: '',
      maxPrice: ''
    };
  };

  const [filters, setFilters] = useState(loadFiltersFromStorage);

    const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [colors, setColors] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [pearlTypes, setPearlTypes] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setFilterOpen] = useState(false);

  // Charger l'ordre de tri depuis sessionStorage
  const loadSortOrderFromStorage = () => {
    try {
      const savedSortOrder = sessionStorage.getItem('catalogueSortOrder');
      return savedSortOrder || 'random';
    } catch (error) {
      console.error('Erreur lors du chargement de l\'ordre de tri:', error);
      return 'random';
    }
  };

  const [sortOrder, setSortOrder] = useState(loadSortOrderFromStorage);

  // Charger la catégorie sélectionnée depuis sessionStorage
  const loadSelectedCategoryFromStorage = () => {
    try {
      const savedCategory = sessionStorage.getItem('catalogueSelectedCategory');
      return savedCategory || 'Toutes';
    } catch (error) {
      console.error('Erreur lors du chargement de la catégorie:', error);
      return 'Toutes';
    }
  };

  const [selectedCategoryTab, setSelectedCategoryTab] = useState(loadSelectedCategoryFromStorage);
  // Nouvel état pour gérer l'ouverture du pop-up des catégories mobiles
  const [isCategoryPopupOpen, setCategoryPopupOpen] = useState(false);


    useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchAndSetData = async () => {
      setLoading(true);
      try {
        const productsList = await pb.collection('products').getFullList({
          filter: 'is_sold = false',
          expand: 'category,color,material,pearl_type',
          requestKey: null
        });
        const categoriesList = await pb.collection('categories').getFullList({ 
          sort: 'name',
          requestKey: null
        });
        const colorsList = await pb.collection('colors').getFullList({ 
          sort: 'name',
          requestKey: null
        });
        const materialsList = await pb.collection('materials').getFullList({ 
          sort: 'name',
          requestKey: null
        });
        const pearlTypesList = await pb.collection('pearl_types').getFullList({ 
          sort: 'name',
          requestKey: null
        });

        setProducts(productsList);
        setCategories(categoriesList);
        setColors(colorsList);
        setMaterials(materialsList);
        setPearlTypes(pearlTypesList);
      } catch (error) {
        if (error.name === 'AbortError' || error.isAbort) {
          return; // Ignore silently
        }
        console.error("Erreur de chargement des données:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAndSetData();

    return () => {
      controller.abort();
    };
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    // Sauvegarder les filtres dans sessionStorage
    try {
      sessionStorage.setItem('catalogueFilters', JSON.stringify(newFilters));
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des filtres:', error);
    }
    // La sidebar ne se ferme plus automatiquement sur mobile pour permettre plusieurs sélections
  };

  // Fonction pour gérer le clic sur un onglet de catégorie (desktop) ou une option du pop-up (mobile)
  const handleCategorySelect = (categoryName) => {
    setSelectedCategoryTab(categoryName);
    
    // Trouver l'ID de la catégorie correspondant au nom
    const selectedCategory = categories.find(cat => cat.name === categoryName);
    const categoryId = selectedCategory ? selectedCategory.id : null;

    // Mettre à jour le filtre de catégorie
    const newFilters = {
      ...filters,
      categories: categoryId ? [categoryId] : []
    };
    setFilters(newFilters);
    
    // Sauvegarder la catégorie et les filtres dans sessionStorage
    try {
      sessionStorage.setItem('catalogueSelectedCategory', categoryName);
      sessionStorage.setItem('catalogueFilters', JSON.stringify(newFilters));
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
    }
    
    // Ferme le pop-up des catégories si ouvert
    setCategoryPopupOpen(false);
  };


    useEffect(() => {
    if (loading) return;
    let tempProducts = [...products];

    // 1. On applique les filtres
        // 1. On applique les filtres
    if (filters.categories && filters.categories.length > 0) {
      tempProducts = tempProducts.filter(p => Array.isArray(p.category) && p.category.some(catId => filters.categories.includes(catId)));
    }
    if (filters.colors && filters.colors.length > 0) {
      tempProducts = tempProducts.filter(p => p.color.some(c => filters.colors.includes(c)));
    }
    if (filters.materials && filters.materials.length > 0) {
      tempProducts = tempProducts.filter(p => p.material.some(m => filters.materials.includes(m)));
    }
    if (filters.pearlTypes && filters.pearlTypes.length > 0) {
      tempProducts = tempProducts.filter(p => p.pearl_type.some(pt => filters.pearlTypes.includes(pt)));
    }
    if (filters.minPrice) {
      tempProducts = tempProducts.filter(p => p.price >= parseFloat(filters.minPrice));
    }
    if (filters.maxPrice) {
      tempProducts = tempProducts.filter(p => p.price <= parseFloat(filters.maxPrice));
    }


    // 2. On applique le tri
    if (sortOrder === 'price-asc') {
      tempProducts.sort((a, b) => a.price - b.price);
    } else if (sortOrder === 'price-desc') {
      tempProducts.sort((a, b) => b.price - a.price);
    } else if (sortOrder === 'random') {
      // Algorithme de mélange Fisher-Yates pour un tri aléatoire
      for (let i = tempProducts.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [tempProducts[i], tempProducts[j]] = [tempProducts[j], tempProducts[i]];
      }
    }

    setFilteredProducts(tempProducts);
  }, [products, filters, sortOrder]); // Le useEffect se déclenche si les filtres OU le tri changent

  // Récupérer toutes les catégories uniques des produits
  const allCategories = ['Toutes', ...categories.map(c => c.name)];

  // Fonctions pour l'édition admin
  const isAdmin = user && user.role === 'admin';

  const startEditing = (product) => {
    setEditingProduct(product.id);
    setEditedProduct({
      name: product.name,
      price: product.price,
      description: product.description,
      stock: product.stock,
      is_unique: product.is_unique,
      is_sold: product.is_sold,
      category: product.category || [],
      color: product.color || [],
      material: product.material || [],
      pearl_type: product.pearl_type || []
    });
  };

  const cancelEditing = () => {
    setEditingProduct(null);
    setEditedProduct({});
  };

  const saveProduct = async (productId) => {
    try {
      const updateData = {
        name: editedProduct.name,
        price: parseFloat(editedProduct.price),
        description: editedProduct.description,
        stock: editedProduct.is_unique ? 1 : parseInt(editedProduct.stock),
        is_unique: editedProduct.is_unique,
        is_sold: editedProduct.is_sold,
        category: editedProduct.category,
        color: editedProduct.color,
        material: editedProduct.material,
        pearl_type: editedProduct.pearl_type
      };

      await pb.collection('products').update(productId, updateData);
      
      // Recharger les produits
      const updatedProducts = await pb.collection('products').getFullList({
        filter: 'is_sold = false',
        expand: 'category,color,material,pearl_type'
      });
      setProducts(updatedProducts);
      
      setEditingProduct(null);
      setEditedProduct({});
      alert('Produit mis à jour avec succès !');
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
      alert('Erreur lors de la mise à jour du produit');
    }
  };

  const handleInputChange = (field, value) => {
    setEditedProduct(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Options pour les selects
  const categoryOptions = categories.map(c => ({ value: c.id, label: c.name }));
  const colorOptions = colors.map(c => ({ value: c.id, label: c.name }));
  const materialOptions = materials.map(m => ({ value: m.id, label: m.name }));
  const pearlTypeOptions = pearlTypes.map(p => ({ value: p.id, label: p.name }));

  return (
    <div className="catalogue-container">
      <div className="catalogue-header">
        <h1>Notre Catalogue Enchanté</h1>
        <p className="catalogue-subtitle">Découvrez nos trésors inspirés par l'océan</p>
      </div>

      {/* Bouton pour ouvrir la sidebar des FILTRES (mobile) */}
      <button className="mobile-filter-btn" onClick={() => setFilterOpen(true)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg>
        <span>Filtrer les créations</span>
      </button>

      {/* Overlay et Sidebar pour les FILTRES (mobile) */}
      <div className={`filter-overlay ${isFilterOpen ? 'show' : ''}`} onClick={() => setFilterOpen(false)}></div>

      <div className="catalogue-body">
        <div className={`filter-sidebar-wrapper ${isFilterOpen ? 'open' : ''}`}>
          <FilterSidebar
            categories={categories}
            colors={colors}
            materials={materials}
            pearlTypes={pearlTypes}
            filters={filters}
            onFilterChange={handleFilterChange}
            onClose={() => setFilterOpen(false)}
          />
        </div>

        <div className="product-grid-wrapper">
          {/* Section pour les contrôles : Catégories (tabs ou bouton/popup) et Tri */}
          <div className="catalogue-controls">
            {/* Version DESKTOP des catégories (tabs défilantes) */}
            <div className="category-tabs desktop-only">
              {allCategories.map(category => (
                <button
                  key={category}
                  className={`category-tab-btn ${selectedCategoryTab === category ? 'active' : ''}`}
                  onClick={() => handleCategorySelect(category)}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Version MOBILE des catégories (bouton pour ouvrir pop-up) */}
            <button className="category-mobile-btn mobile-only" onClick={() => setCategoryPopupOpen(true)}>
              <span>Catégories : </span>
              <strong>{selectedCategoryTab}</strong>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
            </button>

            <div className="sort-bar">
              <label htmlFor="sort-select">Trier par :</label>
              <select id="sort-select" value={sortOrder} onChange={(e) => {
                setSortOrder(e.target.value);
                // Sauvegarder l'ordre de tri dans sessionStorage
                try {
                  sessionStorage.setItem('catalogueSortOrder', e.target.value);
                } catch (error) {
                  console.error('Erreur lors de la sauvegarde du tri:', error);
                }
              }}>
                <option value="random">Aléatoire</option>
                <option value="price-asc">Prix : Croissant</option>
                <option value="price-desc">Prix : Décroissant</option>
              </select>
            </div>
          </div>

          <div className="product-count-container">
            {!loading && (
              <p className="product-count">
                {filteredProducts.length} {filteredProducts.length > 1 ? 'créations trouvées' : 'création trouvée'}
              </p>
            )}
          </div>

          {/* Pop-up des catégories pour mobile */}
          <div className={`category-popup-overlay ${isCategoryPopupOpen ? 'show' : ''}`} onClick={() => setCategoryPopupOpen(false)}>
            <div className="category-popup" onClick={(e) => e.stopPropagation()}> {/* Empêche la fermeture au clic dans le popup */}
              <button className="close-popup-btn" onClick={() => setCategoryPopupOpen(false)}>
                &times;
              </button>
              <h2>Choisir une Catégorie</h2>
              <div className="category-popup-options">
                {allCategories.map(category => (
                  <button
                    key={category}
                    className={`category-option-btn ${selectedCategoryTab === category ? 'active' : ''}`}
                    onClick={() => handleCategorySelect(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          </div>


          {loading ? (
            <p>Chargement des créations...</p>
          ) : filteredProducts.length > 0 ? (
            <div className="product-grid">
              {filteredProducts.map(produit => {
                const isFavorited = favorites.some(item => item.id === produit.id);
                const isEditing = editingProduct === produit.id;
                
                return (
                  <div key={produit.id} className="product-card-wrapper">
                    {!isEditing ? (
                      <Link to={`/catalogue/produit/${produit.slug}`} className="product-card-link">
                        <div className="product-card">
                          <div className="product-image-wrapper">
                            <img src={produit.image && produit.image.length > 0 ? pb.files.getURL(produit, produit.image[0]) : '/placeholder.png'} alt={produit.name} className="product-image" />
                            <button
                              className={`add-to-favorites-btn ${isFavorited ? 'favorited' : ''}`}
                              onClick={(e) => { e.preventDefault(); toggleFavorites(produit); }}
                              aria-label="Ajouter aux favoris"
                            >
                              <svg viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" /></svg>
                            </button>
                          </div>
                          <div className="product-info">
                            <h3 className="product-name">{produit.name}</h3>
                            <p className="product-price">{produit.price ? `${produit.price.toFixed(2)}€` : 'Prix sur demande'}</p>
                            <div className="product-stock">
                              {produit.is_unique ? 'Pièce unique' : (produit.stock > 0 ? `Stock: ${produit.stock}` : 'Rupture de stock')}
                            </div>
                            <button
                              className="add-to-cart-btn"
                              onClick={(e) => { e.preventDefault(); addToCart(produit); }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                              Ajouter au panier
                            </button>
                          </div>
                        </div>
                      </Link>
                    ) : (
                      <div className="product-card product-card-editing">
                        <div className="product-image-wrapper">
                          <img src={produit.image && produit.image.length > 0 ? pb.files.getURL(produit, produit.image[0]) : '/placeholder.png'} alt={produit.name} className="product-image" />
                        </div>
                        <div className="product-edit-form">
                          <input
                            type="text"
                            value={editedProduct.name}
                            onChange={(e) => handleInputChange('name', e.target.value)}
                            className="edit-input"
                            placeholder="Nom du produit"
                          />
                          <input
                            type="number"
                            value={editedProduct.price}
                            onChange={(e) => handleInputChange('price', e.target.value)}
                            className="edit-input"
                            placeholder="Prix"
                            step="0.01"
                          />
                          <textarea
                            value={editedProduct.description}
                            onChange={(e) => handleInputChange('description', e.target.value)}
                            className="edit-textarea"
                            placeholder="Description"
                            rows="3"
                          />
                          
                          <div className="edit-checkboxes">
                            <label>
                              <input
                                type="checkbox"
                                checked={editedProduct.is_unique}
                                onChange={(e) => handleInputChange('is_unique', e.target.checked)}
                              />
                              Pièce unique
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                checked={editedProduct.is_sold}
                                onChange={(e) => handleInputChange('is_sold', e.target.checked)}
                              />
                              Vendu
                            </label>
                          </div>

                          {!editedProduct.is_unique && (
                            <input
                              type="number"
                              value={editedProduct.stock}
                              onChange={(e) => handleInputChange('stock', e.target.value)}
                              className="edit-input"
                              placeholder="Stock"
                              min="0"
                            />
                          )}

                          <Select
                            isMulti
                            options={categoryOptions}
                            value={categoryOptions.filter(option => editedProduct.category.includes(option.value))}
                            onChange={(selected) => handleInputChange('category', selected ? selected.map(s => s.value) : [])}
                            placeholder="Catégories"
                            className="edit-select"
                          />

                          <Select
                            isMulti
                            options={colorOptions}
                            value={colorOptions.filter(option => editedProduct.color.includes(option.value))}
                            onChange={(selected) => handleInputChange('color', selected ? selected.map(s => s.value) : [])}
                            placeholder="Couleurs"
                            className="edit-select"
                          />

                          <Select
                            isMulti
                            options={materialOptions}
                            value={materialOptions.filter(option => editedProduct.material.includes(option.value))}
                            onChange={(selected) => handleInputChange('material', selected ? selected.map(s => s.value) : [])}
                            placeholder="Matériaux"
                            className="edit-select"
                          />

                          <Select
                            isMulti
                            options={pearlTypeOptions}
                            value={pearlTypeOptions.filter(option => editedProduct.pearl_type.includes(option.value))}
                            onChange={(selected) => handleInputChange('pearl_type', selected ? selected.map(s => s.value) : [])}
                            placeholder="Types de perles"
                            className="edit-select"
                          />

                          <div className="edit-controls">
                            <button className="save-btn" onClick={() => saveProduct(produit.id)}>
                              ✅ Sauvegarder
                            </button>
                            <button className="cancel-btn" onClick={cancelEditing}>
                              ❌ Annuler
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Bouton d'édition admin pour chaque produit */}
                    {isAdmin && !isEditing && (
                      <div className="admin-controls-gallery">
                        <button className="edit-btn-gallery" onClick={(e) => { e.preventDefault(); startEditing(produit); }}>
                          ✏️ Modifier
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="no-results-message">Aucun produit ne correspond à vos filtres.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Catalogue;